module.exports = {
  AVALIADOR: 1,
  ELABORADOR: 2,
  ALUNO: 3,
  ADMINISTRADOR: 4
};



// WEBPACK FOOTER //
// ./src/domain/prova/TipoUsuarioEnum.js